import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { Router } from '@angular/router';
import { XWareLogService } from '../../services/xware-log.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'xware-main-canvas',
  templateUrl: './main-canvas.component.html',
  styleUrls: ['./main-canvas.component.scss'],
})
export class MainCanvasComponent implements OnInit, OnDestroy {
  bIsOnboarding = true;
  bIsLoading = true;
  cmsAvailable = true;
  bIsExpired = false;
  bInvalidID = false;
  private destroy$ = new Subject<void>();

  constructor(
    public loginService: LoginService,
    private logger: XWareLogService,
    public router: Router
  ) {}

  ngOnInit() {
    if (sessionStorage.getItem('adType') == 'gapi') {
      this.bIsOnboarding = false;
    }

    this.loginService.portaluserLatest.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        const isCurrent = data.graphRegion !== 'W';
        this.getStatus(isCurrent);
      } else {
        this.getStatus(false);
      }
    });
  }

  getStatus(isAuthCurrent: boolean) {
    this.logger.log('mainCanvas: getStatus called');
    this.loginService.navStart.pipe(takeUntil(this.destroy$)).subscribe({
      next: data => {
        if (data) {
          this.bIsLoading = false;
          this.cmsAvailable = true;

          if (data === 'expired') {
            this.bIsLoading = false;
            this.bIsOnboarding = false;
            this.cmsAvailable = true;
            this.bIsExpired = true;
          } else if (data === 'setup') {
            this.bIsOnboarding = true;
          } else if (data === 'error') {
            this.bIsLoading = false;
            this.bIsOnboarding = false;
            this.cmsAvailable = false;
          } else if (data === 'invalid') {
            this.bIsLoading = false;
            this.bIsOnboarding = false;
            this.cmsAvailable = false;
            this.bInvalidID = true;
          } else {
            this.bIsOnboarding = false;
            this.logger.log('mainCanvas: customer > isAuthCurrent= ' + isAuthCurrent + ' called');
            this.bIsLoading = false;
          }
        } else {
          this.bIsLoading = true;
        }
      },
      error: () => {
        this.bIsLoading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
